import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";

import { CommonModule } from "@angular/common";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { IApplicants } from "../../models/applicants-list.model";
import { ApplicantsListService } from "../../services/applicants-list.service";

@Component({
    selector: "app-iap-applications",
    imports: [
        CommonModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatCardModule,
        MatTableModule,
        MatSortModule,
        MatButtonModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
    ],
    templateUrl: "./applications.component.html",
    styleUrls: [
        "./applications.component.scss",
        "../../../shared/styles/commonList.css",
    ]
})
export class ApplicationsComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  ELEMENT_DATA: any[] = [];

  displayedColumns: string[] = [
    "fullName",
    "applicationNumber",
    "studentNumber",
    "term",
    "programName",
    "campus",
    "statusDate",
    "applicationStatus",
    "offerLetter",
  ];
  dataSource!: MatTableDataSource<any>;

  ApplicantList!: IApplicants[];

  communicationPdfLoading: boolean;

  constructor(private service: ApplicantsListService) {
    this.communicationPdfLoading = false;
  }

  ngAfterViewInit() {
    if (this.paginator) {
      this.paginator.pageSize = 10;
    } else {
      console.warn("Paginator not yet initialized");
    }
  }

  ngOnInit() {
    this.refreshData();
  }

  refreshData() {
    this.service.getAllApplicantsList().subscribe((appllist: IApplicants[]) => {
      if (appllist != null) {
        this.ApplicantList = appllist;
        this.ELEMENT_DATA = appllist;
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      }
    });
  }
  // filters
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement)?.value
      .trim()
      .toLowerCase();
    this.dataSource.filter = filterValue;
  }

  openOfferLetter(application: any) {
    this.communicationPdfLoading = true;
    this.service
      .getOfferLetterPdf(
        application.studentNumber,
        application.applicationNumber,
        application.ApplProgNbr
      )
      .subscribe((offerLetterData: any[]) => {
        this.communicationPdfLoading = false;
        offerLetterData.forEach((pdfData) => {
          const linkSource = "data:application/pdf;base64," + pdfData.FILEDATA;
          const downloadLink = document.createElement("a");
          const fileName =
            application.studentNumber +
            "-" +
            application.fullName +
            "-" +
            pdfData.FILENAME;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
        });
      });
  }
}
